import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { rateService } from '@/api/admin/services/rate.service';
import type { RateCardPayload } from '@/types/dashboard/rate';

// Shared with the kiosk form's rate-card picker, so both stay in sync after a save.
export const rateKeys = { list: ['admin', 'rate-charges'] as const };

export function useRateCards() {
  return useQuery({ queryKey: rateKeys.list, queryFn: () => rateService.list() });
}

export function useCreateRate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: RateCardPayload) => rateService.create(payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: rateKeys.list }),
  });
}

export function useUpdateRate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: Partial<RateCardPayload> }) =>
      rateService.update(id, payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: rateKeys.list }),
  });
}

export function useDeleteRate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => rateService.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: rateKeys.list }),
  });
}
